import api from './APIService';

class BillingService {
	getPaymentList() {
		return api.fetch({ method: 'get', path: '/participant/getPaymentList' });
	}
}

export default new BillingService();